import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import RootQuoteGroup from "./RootQuoteGroup";
import QuoteIndex from "./QuoteIndex";
import styled from "styled-components";
import QuoteHelp from "./QuoteHelp";

const QuoteDiv = styled.div`
  padding: 40px;
  background: white;
  border: 1px solid #ddd;
  max-width: 1400px;
  margin: 0 auto;
  margin-top: 0px;
  margin-bottom: 30px;
`;

const QuoteTitle = styled.h2`
  text-align: center;
  margin-top: 0;
  margin-bottom: 30px;
`;

class QuoteEditor extends React.Component {
  state = {
    root_quote_group_ids: []
  };

  componentDidMount() {
    const { root_quote_group_ids } = this.props;
    if (root_quote_group_ids) this.setState({ root_quote_group_ids });
  }

  setRootQuoteGroups = root_quote_group_ids => {
    this.setState({ root_quote_group_ids });
  };

  addRootQuoteGroups = new_root_quote_group_ids => {
    const { root_quote_group_ids } = this.state;
    this.setRootQuoteGroups(root_quote_group_ids.concat(new_root_quote_group_ids));
  };

  onGroupAdded = new_root_quote_group_id => {
    this.addRootQuoteGroups([new_root_quote_group_id]);
    this.toggleAddingNewGroup();
  };

  removeGroup = root_quote_group_id => {
    this.quoteIndex.refresh();
    this.setState({
      root_quote_group_ids: this.state.root_quote_group_ids.filter(
        id => id !== root_quote_group_id
      )
    });
  };

  refresh = () => {};

  actions = () => {
    return {
      setRootQuoteGroups: this.setRootQuoteGroups
    };
  };

  render() {
    const { attempt_id } = this.props;
    const { root_quote_group_ids } = this.state;
    const actions = this.actions();
    return (
      <QuoteDiv className="shadow">
        <QuoteIndex
          ref={ref => (this.quoteIndex = ref)}
          attempt_id={attempt_id}
          visible_quote_group_ids={root_quote_group_ids}
          selectQuoteGroups={this.setRootQuoteGroups}
        />

        <QuoteHelp />

        {root_quote_group_ids.map(quote_group_id => (
          <RootQuoteGroup
            onRemoveGroup={this.removeGroup}
            actions={actions}
            attempt_id={attempt_id}
            key={quote_group_id}
            root_quote_group_id={quote_group_id}
          />
        ))}
      </QuoteDiv>
    );
  }
}

export default QuoteEditor;
